import { IAMUser, useDMSAuth } from 'drive-ui-packages';
import { FC, ReactNode } from 'react';
import { IntlProvider } from 'react-intl';
import { APP_ENV } from 'adapters/constants';
import { DEFAULT_LOCALE } from 'common/constants';
import { loadMessages } from 'i18n';

export const LocaleProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { dmsAuthSession } = useDMSAuth(APP_ENV);
  const iamUser = dmsAuthSession.oktaUser?.iamUser as IAMUser | undefined;
  const iamLocale = iamUser?.locale?.replace('_', '-');

  const messages = loadMessages(iamLocale ?? DEFAULT_LOCALE);

  return (
    <IntlProvider
      locale={iamLocale ?? DEFAULT_LOCALE}
      defaultLocale={DEFAULT_LOCALE}
      messages={messages}
    >
      {children}
    </IntlProvider>
  );
};
